/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CommonDictionaryItemDtoFromJSON, CommonDictionaryItemDtoToJSON, } from './';
export function TiresDictionaryFromJSON(json) {
    return TiresDictionaryFromJSONTyped(json, false);
}
export function TiresDictionaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'makeDictionary': !exists(json, 'makeDictionary') ? undefined : (json['makeDictionary'] === null ? null : json['makeDictionary'].map(CommonDictionaryItemDtoFromJSON)),
        'diameterDictionary': !exists(json, 'diameterDictionary') ? undefined : (json['diameterDictionary'] === null ? null : json['diameterDictionary'].map(CommonDictionaryItemDtoFromJSON)),
        'ratioDictionary': !exists(json, 'ratioDictionary') ? undefined : (json['ratioDictionary'] === null ? null : json['ratioDictionary'].map(CommonDictionaryItemDtoFromJSON)),
        'widthDictionary': !exists(json, 'widthDictionary') ? undefined : (json['widthDictionary'] === null ? null : json['widthDictionary'].map(CommonDictionaryItemDtoFromJSON)),
    };
}
export function TiresDictionaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'makeDictionary': value.makeDictionary === undefined ? undefined : (value.makeDictionary === null ? null : value.makeDictionary.map(CommonDictionaryItemDtoToJSON)),
        'diameterDictionary': value.diameterDictionary === undefined ? undefined : (value.diameterDictionary === null ? null : value.diameterDictionary.map(CommonDictionaryItemDtoToJSON)),
        'ratioDictionary': value.ratioDictionary === undefined ? undefined : (value.ratioDictionary === null ? null : value.ratioDictionary.map(CommonDictionaryItemDtoToJSON)),
        'widthDictionary': value.widthDictionary === undefined ? undefined : (value.widthDictionary === null ? null : value.widthDictionary.map(CommonDictionaryItemDtoToJSON)),
    };
}
